import { makeAuthenticatedApiCall } from './authApi';
import { ZCLUB_API_URL } from '../config/api';

const base = `${ZCLUB_API_URL}/spinning-wheel`;

export const getActiveSpinningWheel = async (platform = 'club', entrySource = 'app', programCode = null) => {
  let url = `${base}/active?platform=${encodeURIComponent(platform)}&entry_source=${encodeURIComponent(entrySource)}`;
  if (programCode) {
    url += `&program_code=${encodeURIComponent(programCode)}`;
  }
  const response = await makeAuthenticatedApiCall(url, { method: 'GET' });
  if (!response || response.code !== 200 || response.status !== 'success') {
    throw new Error(response?.message || 'Gagal memuat program spinning wheel');
  }
  return response.data;
};

export const postSpinningWheel = async (platform = 'club', entrySource = 'app', programCode = null) => {
  const body = { platform, entry_source: entrySource };
  if (programCode) {
    body.program_code = programCode;
  }
  const response = await makeAuthenticatedApiCall(`${base}/spin`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
  if (!response || response.code !== 200 || response.status !== 'success') {
    throw new Error(response?.message || 'Spin gagal');
  }
  return response.data;
};

/** Klaim hadiah produk: pengiriman (pesanan) atau booth/event offline sesuai program — backend mengabaikan id_alamat untuk offline_event. */
export const postSpinWheelClaimProduct = async (spinLogId, idAlamat = null) => {
  const body = { spin_log_id: spinLogId };
  if (idAlamat != null && Number(idAlamat) > 0) {
    body.id_alamat = Number(idAlamat);
  }
  const response = await makeAuthenticatedApiCall(`${base}/claim-product`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
  if (!response || response.code !== 200 || response.status !== 'success') {
    throw new Error(response?.message || 'Klaim hadiah gagal');
  }
  return response.data;
};

/** Riwayat klaim / menang spinning wheel (session). */
export const getSpinningWheelClaimHistory = async () => {
  const response = await makeAuthenticatedApiCall(`${base}/my-history`, { method: 'GET' });
  if (!response || response.code !== 200 || response.status !== 'success') {
    throw new Error(response?.message || 'Gagal memuat riwayat klaim hadiah');
  }
  return response.data;
};

/** Hadiah produk menang yang belum diklaim (reclaim). */
export const getPendingSpinProductClaims = async () => {
  const response = await makeAuthenticatedApiCall(`${base}/pending-product-claims`, { method: 'GET' });
  if (!response || response.code !== 200 || response.status !== 'success') {
    throw new Error(response?.message || 'Gagal memuat hadiah belum diklaim');
  }
  return response.data;
};
